import { Component, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "common-back-to-page-link",
  templateUrl: "./back-to-page-link.component.html",
})
export class BackToPageLinkComponent {
  @Input() text: string = "Back to list";
  @Input() urlToNavigate: string = "../";

  queryParams: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.queryParams = this.router["lastSuccessfulNavigation"]?.previousNavigation?.finalUrl?.queryParams || null;
  }
}
